<app-page-breadcrumb pageTitle="Reglas de escalación"></app-page-breadcrumb>

<div class="space-y-4">
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-2">
      <input type="text" [(ngModel)]="filtroNombre" (ngModelChange)="aplicarFiltros()"
        placeholder="Buscar..."
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" [(ngModel)]="filtroSoloActivas" (ngModelChange)="aplicarFiltros()"
          class="rounded border-gray-300 dark:border-gray-600" />
        Solo activas
      </label>
    </div>
    <div class="flex items-center gap-1.5">
      <button type="button" (click)="volverATickets()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        ← Tickets
      </button>
      <button type="button" (click)="nuevo()" *appHasPermission="'tickets:create'"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nueva regla
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div></div>
  }
  @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Prioridad</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Trigger</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Acción</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Activa</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (filtered.length === 0) {
            <tr><td colspan="6" class="px-5 py-8 text-center text-sm text-gray-500 dark:text-gray-400">Sin reglas de escalación.</td></tr>
          }
          @for (item of filtered; track item.id) {
          <tr>
            <td class="px-5 py-3 text-sm text-gray-700 dark:text-gray-300">{{ priorityLabel(item.priority) }}</td>
            <td class="px-5 py-3 text-sm font-medium text-gray-900 dark:text-white">
              {{ item.name }}
              @if (item.description) {
                <p class="text-xs text-gray-500 font-normal">{{ item.description }}</p>
              }
            </td>
            <td class="px-5 py-3 text-sm">
              <span class="text-xs px-2 py-0.5 rounded bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300">{{ triggerLabel(item.triggerType) }}</span>
            </td>
            <td class="px-5 py-3 text-sm">
              <span class="text-xs px-2 py-0.5 rounded bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">{{ actionLabel(item.actionType) }}</span>
            </td>
            <td class="px-5 py-3">
              <button type="button" (click)="toggleActiva(item)" *appHasPermission="'tickets:edit'"
                class="text-xs px-2 py-0.5 rounded-full font-medium transition-colors"
                [ngClass]="item.isActive
                  ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'">
                {{ item.isActive ? 'Activa' : 'Inactiva' }}
              </button>
            </td>
            <td class="px-5 py-3 text-center">
              <div class="flex items-center justify-center gap-2">
                <button (click)="editar(item)" title="Editar" *appHasPermission="'tickets:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                <button (click)="eliminar(item)" title="Eliminar" *appHasPermission="'tickets:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
